import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsContent } from '@icms/core/content';
import { IPageHeaderBlockContent } from '../header/page-header.interface';
@Component({
    selector: 'special-menu',
    templateUrl: './special-menu.html',
    standalone: true,
    imports: [DfUiModule, NgClass, ImageModule, HrefComponent, ICmsClientModule, CarouselModule, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpecialMenuComponent extends UiComponent {
    @ICmsContent({
        watchDepth: 2
    })
    @Input({ required: true })
    data!: IPageHeaderBlockContent;
}
